import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { themeStyle, themeStyleDark } from "../components/Components";
import Sidebar from "../components/Sidebar";
import Footer from "../components/Footer";
import {
  ContentSideBySide,
  ContentSideBySideInv,
  ThreeSideBySide,
  Hero,
  Gallery,
  SpacerV,
  FeatureCard,
  Stats,
  FeatureCardSmall,
  News,
} from "../components/Hero";
import { API_URL } from "../actions/auth";
import axios from "axios";
import bg from "../img/bg.mp4";
import { useNavigate } from "react-router";
import CellTowerIcon from "@mui/icons-material/CellTower";
import SupportAgentIcon from "@mui/icons-material/SupportAgent";
import AttachMoneyIcon from "@mui/icons-material/AttachMoney";
import CheckroomIcon from "@mui/icons-material/Checkroom";
import HealthAndSafetyIcon from "@mui/icons-material/HealthAndSafety";
import AccountBalanceIcon from "@mui/icons-material/AccountBalance";
import CorporateFareIcon from "@mui/icons-material/CorporateFare";
import ShoppingCartIcon from "@mui/icons-material/ShoppingCart";
import EqualizerIcon from "@mui/icons-material/Equalizer";
import AssignmentIndIcon from "@mui/icons-material/AssignmentInd";
import WorkIcon from "@mui/icons-material/Work";
import AutoGraphIcon from "@mui/icons-material/AutoGraph";
import BuildIcon from "@mui/icons-material/Build";
import EngineeringIcon from "@mui/icons-material/Engineering";
import PersonIcon from "@mui/icons-material/Person";
import Lottie from "react-lottie";
import { Grid } from "@mui/material";
import { TypeAnimation } from "react-type-animation";
import { useInView, useSpring, animated } from "@react-spring/web";
import ArrowRightIcon from "@mui/icons-material/ArrowRight";
import ArrowLeftIcon from "@mui/icons-material/ArrowLeft";
import { Up, Down, Left, Right } from "../components/PositionFade";
import AcUnitIcon from "@mui/icons-material/AcUnit";
import FormatQuoteIcon from "@mui/icons-material/FormatQuote";
import {
  useSpringCarousel,
  useTransitionCarousel,
} from "react-spring-carousel";

export default function WhatWeDo() {
  useEffect(() => {
    axios
      .get(API_URL + "get_news")
      .then((res) => {
        setNews(Array.isArray(res.data) ? res.data : []);
      })
      .catch((err) => {
        console.error("Error fetching news:", err);
        setNews([]);
      });
    axios
      .get(API_URL + "get_gallery")
      .then((res) => {
        setGallery(Array.isArray(res.data) ? res.data : []);
      })
      .catch((err) => {
        console.error("Error fetching gallery:", err);
        setGallery([]);
      });
  }, []);

  const [news, setNews] = useState([]);
  const [gallery, setGallery] = useState([]);

  const [zoom1, zoom1api] = useSpring(() => ({
    from: { transform: "scale(1)" },
  }));

  const [zoom2, zoom2api] = useSpring(() => ({
    from: { transform: "scale(1)" },
  }));

  const navigate = useNavigate();
  const state = useSelector((state) => state);

  const { carouselFragment, slideToPrevItem, slideToNextItem } =
    useSpringCarousel({
      withLoop: true,
      items: [
        {
          id: "item-1",
          renderItem: (
            <section>
              <div className={"vidhero"}>
                <div
                  className="imgback"
                  style={{
                    marginTop: "-25px",
                    borderRadius: "25px",
                    backgroundColor: "white",
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    justifyContent: "center",
                    padding: "50px",
                    color: "black",
                  }}
                >
                  <div
                    style={{
                      marginTop: "-25px",
                      borderRadius: "25px",
                    }}
                  >
                    <FormatQuoteIcon
                      style={{
                        fontSize: state.auth.isMobile ? "50px" : "80px",
                      }}
                    />
                  </div>
                  <div
                    style={{
                      fontSize: state.auth.isMobile ? "20px" : "30px",
                    }}
                  >
                    The collaboration with your team has been nothing short of
                    extraordinary. Your innovative approach and attention to
                    detail have set a new benchmark in excellence. We're
                    thrilled to have partnered with you!
                  </div>
                  <div
                    style={{
                      borderRadius: "25px",
                    }}
                  >
                    <FormatQuoteIcon
                      style={{
                        fontSize: state.auth.isMobile ? "50px" : "80px",
                      }}
                    />
                  </div>
                  <div
                    style={{
                      fontSize: state.auth.isMobile ? "15px" : "20px",
                    }}
                  >
                    -Sarah Miller
                  </div>
                  <div
                    style={{
                      fontSize: state.auth.isMobile ? "10px" : "16px",
                      color: "grey",
                    }}
                  >
                    CEO of TechVantage Solutions
                  </div>
                </div>
                <animated.div
                  onClick={() => {
                    slideToNextItem();
                  }}
                  onMouseEnter={() => {
                    zoom1api.start({
                      from: {
                        transform: "scale(1)",
                      },
                      to: {
                        transform: "scale(1.1)",
                      },
                    });
                  }}
                  onMouseLeave={() => {
                    zoom1api.start({
                      from: {
                        transform: "scale(1.1)",
                      },
                      to: {
                        transform: "scale(1)",
                      },
                    });
                  }}
                  style={{
                    display: state.auth.isMobile ? "none" : "flex",
                    position: "absolute",
                    width: "80px",
                    height: "80px",
                    border: "2px solid white",
                    borderRadius: "100px",
                    top: "20vh",
                    right: 75,
                    justifyContent: "center",
                    alignItems: "center",
                    cursor: "pointer",
                    ...zoom1,
                  }}
                >
                  <ArrowRightIcon
                    style={{ fontSize: "75px", color: "white" }}
                  />
                </animated.div>
                <animated.div
                  onClick={() => {
                    slideToPrevItem();
                  }}
                  onMouseEnter={() => {
                    zoom2api.start({
                      from: {
                        transform: "scale(1)",
                      },
                      to: {
                        transform: "scale(1.1)",
                      },
                    });
                  }}
                  onMouseLeave={() => {
                    zoom2api.start({
                      from: {
                        transform: "scale(1.1)",
                      },
                      to: {
                        transform: "scale(1)",
                      },
                    });
                  }}
                  style={{
                    display: state.auth.isMobile ? "none" : "flex",
                    position: "absolute",
                    width: "80px",
                    height: "80px",
                    border: "2px solid white",
                    borderRadius: "100px",
                    top: "32vh",
                    right: 75,
                    justifyContent: "center",
                    alignItems: "center",
                    cursor: "pointer",
                    ...zoom2,
                  }}
                >
                  <ArrowLeftIcon style={{ fontSize: "75px", color: "white" }} />
                </animated.div>
              </div>
            </section>
          ),
        },
        {
          id: "item-2",
          renderItem: (
            <section>
              <div className={"vidhero"}>
                <div
                  className="imgback"
                  style={{
                    marginTop: "-25px",
                    borderRadius: "25px",
                    backgroundColor: "white",
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    justifyContent: "center",
                    padding: "50px",
                    color: "black",
                  }}
                >
                  <div
                    style={{
                      marginTop: "-25px",
                      borderRadius: "25px",
                    }}
                  >
                    <FormatQuoteIcon
                      style={{
                        fontSize: state.auth.isMobile ? "50px" : "80px",
                      }}
                    />
                  </div>
                  <div
                    style={{
                      fontSize: state.auth.isMobile ? "20px" : "30px",
                    }}
                  >
                    CGT team knew how to turn an idea into a visual product. We
                    were impressed with the research they did with our
                    competitors to really understand our space & the product
                    we're creating.
                  </div>
                  <div
                    style={{
                      borderRadius: "25px",
                    }}
                  >
                    <FormatQuoteIcon
                      style={{
                        fontSize: state.auth.isMobile ? "50px" : "80px",
                      }}
                    />
                  </div>
                  <div
                    style={{
                      fontSize: state.auth.isMobile ? "15px" : "20px",
                    }}
                  >
                    - Mohamed Shegow
                  </div>
                  <div
                    style={{
                      fontSize: state.auth.isMobile ? "10px" : "16px",
                      color: "grey",
                    }}
                  >
                    CEO at Sinta Inc.
                  </div>
                </div>
                <animated.div
                  onClick={() => {
                    slideToNextItem();
                  }}
                  onMouseEnter={() => {
                    zoom1api.start({
                      from: {
                        transform: "scale(1)",
                      },
                      to: {
                        transform: "scale(1.1)",
                      },
                    });
                  }}
                  onMouseLeave={() => {
                    zoom1api.start({
                      from: {
                        transform: "scale(1.1)",
                      },
                      to: {
                        transform: "scale(1)",
                      },
                    });
                  }}
                  style={{
                    display: state.auth.isMobile ? "none" : "flex",
                    position: "absolute",
                    width: "80px",
                    height: "80px",
                    border: "2px solid white",
                    borderRadius: "100px",
                    top: "20vh",
                    right: 75,
                    justifyContent: "center",
                    alignItems: "center",
                    cursor: "pointer",
                    ...zoom1,
                  }}
                >
                  <ArrowRightIcon
                    style={{ fontSize: "75px", color: "white" }}
                  />
                </animated.div>
                <animated.div
                  onClick={() => {
                    slideToPrevItem();
                  }}
                  onMouseEnter={() => {
                    zoom2api.start({
                      from: {
                        transform: "scale(1)",
                      },
                      to: {
                        transform: "scale(1.1)",
                      },
                    });
                  }}
                  onMouseLeave={() => {
                    zoom2api.start({
                      from: {
                        transform: "scale(1.1)",
                      },
                      to: {
                        transform: "scale(1)",
                      },
                    });
                  }}
                  style={{
                    display: state.auth.isMobile ? "none" : "flex",
                    position: "absolute",
                    width: "80px",
                    height: "80px",
                    border: "2px solid white",
                    borderRadius: "100px",
                    top: "32vh",
                    right: 75,
                    justifyContent: "center",
                    alignItems: "center",
                    cursor: "pointer",
                    ...zoom2,
                  }}
                >
                  <ArrowLeftIcon style={{ fontSize: "75px", color: "white" }} />
                </animated.div>
              </div>
            </section>
          ),
        },
        {
          id: "item-3",
          renderItem: (
            <section>
              <div className={"vidhero"}>
                <div
                  className="imgback"
                  style={{
                    marginTop: "-25px",
                    borderRadius: "25px",
                    backgroundColor: "white",
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    justifyContent: "center",
                    padding: "50px",
                    color: "black",
                  }}
                >
                  <div
                    style={{
                      marginTop: "-25px",
                      borderRadius: "25px",
                    }}
                  >
                    <FormatQuoteIcon
                      style={{
                        fontSize: state.auth.isMobile ? "50px" : "80px",
                      }}
                    />
                  </div>
                  <div
                    style={{
                      fontSize: state.auth.isMobile ? "20px" : "30px",
                    }}
                  >
                    Your company has redefined professionalism and creativity.
                    The results you delivered exceeded our expectations and have
                    had a profound impact on our business. Thank you for being
                    such an exceptional partner.
                  </div>
                  <div
                    style={{
                      borderRadius: "25px",
                    }}
                  >
                    <FormatQuoteIcon
                      style={{
                        fontSize: state.auth.isMobile ? "50px" : "80px",
                      }}
                    />
                  </div>
                  <div
                    style={{
                      fontSize: state.auth.isMobile ? "15px" : "20px",
                    }}
                  >
                    -David Johnson
                  </div>
                  <div
                    style={{
                      fontSize: state.auth.isMobile ? "10px" : "16px",
                      color: "grey",
                    }}
                  >
                    CEO of BrightPath Enterprises
                  </div>
                </div>
                <animated.div
                  onClick={() => {
                    slideToNextItem();
                  }}
                  onMouseEnter={() => {
                    zoom1api.start({
                      from: {
                        transform: "scale(1)",
                      },
                      to: {
                        transform: "scale(1.1)",
                      },
                    });
                  }}
                  onMouseLeave={() => {
                    zoom1api.start({
                      from: {
                        transform: "scale(1.1)",
                      },
                      to: {
                        transform: "scale(1)",
                      },
                    });
                  }}
                  style={{
                    display: state.auth.isMobile ? "none" : "flex",
                    position: "absolute",
                    width: "80px",
                    height: "80px",
                    border: "2px solid white",
                    borderRadius: "100px",
                    top: "20vh",
                    right: 75,
                    justifyContent: "center",
                    alignItems: "center",
                    cursor: "pointer",
                    ...zoom1,
                  }}
                >
                  <ArrowRightIcon
                    style={{ fontSize: "75px", color: "white" }}
                  />
                </animated.div>
                <animated.div
                  onClick={() => {
                    slideToPrevItem();
                  }}
                  onMouseEnter={() => {
                    zoom2api.start({
                      from: {
                        transform: "scale(1)",
                      },
                      to: {
                        transform: "scale(1.1)",
                      },
                    });
                  }}
                  onMouseLeave={() => {
                    zoom2api.start({
                      from: {
                        transform: "scale(1.1)",
                      },
                      to: {
                        transform: "scale(1)",
                      },
                    });
                  }}
                  style={{
                    display: state.auth.isMobile ? "none" : "flex",
                    position: "absolute",
                    width: "80px",
                    height: "80px",
                    border: "2px solid white",
                    borderRadius: "100px",
                    top: "32vh",
                    right: 75,
                    justifyContent: "center",
                    alignItems: "center",
                    cursor: "pointer",
                    ...zoom2,
                  }}
                >
                  <ArrowLeftIcon style={{ fontSize: "75px", color: "white" }} />
                </animated.div>
              </div>
            </section>
          ),
        },
        {
          id: "item-4",
          renderItem: (
            <section>
              <div className={"vidhero"}>
                <div
                  className="imgback"
                  style={{
                    marginTop: "-25px",
                    borderRadius: "25px",
                    backgroundColor: "white",
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    justifyContent: "center",
                    padding: "50px",
                    color: "black",
                  }}
                >
                  <div
                    style={{
                      marginTop: "-25px",
                      borderRadius: "25px",
                    }}
                  >
                    <FormatQuoteIcon
                      style={{
                        fontSize: state.auth.isMobile ? "50px" : "80px",
                      }}
                    />
                  </div>
                  <div
                    style={{
                      fontSize: state.auth.isMobile ? "20px" : "30px",
                    }}
                  >
                    Working with your team has been an absolute pleasure. Your
                    dedication, expertise, and ability to deliver outstanding
                    results have significantly contributed to our success. We're
                    looking forward to many more collaborations ahead.
                  </div>
                  <div
                    style={{
                      borderRadius: "25px",
                    }}
                  >
                    <FormatQuoteIcon
                      style={{
                        fontSize: state.auth.isMobile ? "50px" : "80px",
                      }}
                    />
                  </div>
                  <div
                    style={{
                      fontSize: state.auth.isMobile ? "15px" : "20px",
                    }}
                  >
                    - Emily Carter
                  </div>
                  <div
                    style={{
                      fontSize: state.auth.isMobile ? "10px" : "16px",
                      color: "grey",
                    }}
                  >
                    CEO of GreenWay Innovations
                  </div>
                </div>
                <animated.div
                  onClick={() => {
                    slideToNextItem();
                  }}
                  onMouseEnter={() => {
                    zoom1api.start({
                      from: {
                        transform: "scale(1)",
                      },
                      to: {
                        transform: "scale(1.1)",
                      },
                    });
                  }}
                  onMouseLeave={() => {
                    zoom1api.start({
                      from: {
                        transform: "scale(1.1)",
                      },
                      to: {
                        transform: "scale(1)",
                      },
                    });
                  }}
                  style={{
                    display: state.auth.isMobile ? "none" : "flex",
                    position: "absolute",
                    width: "80px",
                    height: "80px",
                    border: "2px solid white",
                    borderRadius: "100px",
                    top: "20vh",
                    right: 75,
                    justifyContent: "center",
                    alignItems: "center",
                    cursor: "pointer",
                    ...zoom1,
                  }}
                >
                  <ArrowRightIcon
                    style={{ fontSize: "75px", color: "white" }}
                  />
                </animated.div>
                <animated.div
                  onClick={() => {
                    slideToPrevItem();
                  }}
                  onMouseEnter={() => {
                    zoom2api.start({
                      from: {
                        transform: "scale(1)",
                      },
                      to: {
                        transform: "scale(1.1)",
                      },
                    });
                  }}
                  onMouseLeave={() => {
                    zoom2api.start({
                      from: {
                        transform: "scale(1.1)",
                      },
                      to: {
                        transform: "scale(1)",
                      },
                    });
                  }}
                  style={{
                    display: state.auth.isMobile ? "none" : "flex",
                    position: "absolute",
                    width: "80px",
                    height: "80px",
                    border: "2px solid white",
                    borderRadius: "100px",
                    top: "32vh",
                    right: 75,
                    justifyContent: "center",
                    alignItems: "center",
                    cursor: "pointer",
                    ...zoom2,
                  }}
                >
                  <ArrowLeftIcon style={{ fontSize: "75px", color: "white" }} />
                </animated.div>
              </div>
            </section>
          ),
        },
      ],
    });

  useEffect(() => {
    const timer = setInterval(() => {
      slideToNextItem();
    }, 10000);
    return () => {
      window.clearInterval(timer);
    };
  }, [slideToNextItem]);

  function getContent() {
    return (
      <div className="main">
        <Sidebar />

        <div className="overlay"></div>

        <video
          src={bg}
          type="video/mp4"
          autoPlay
          loop
          muted
          id="video"
          className="video"
        />
        <div
          className="content"
          style={{
            position: "absolute",
            height: "100vh",
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            alignItems: "center",
            width: "100vw",
          }}
        >
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              justifyContent: "flex-start",
              alignItems: "flex-start",
              width: "75vw",
            }}
          >
            <div
              style={{
                paddingTop: state.auth.isMobile ? "100px" : "0px",
                fontSize: state.auth.isMobile ? "60px" : "75px",
                color: "white",
                zIndex: 999,
                textAlign: state.auth.isMobile ? "left" : "center",
              }}
            >
              CGT Solutions
            </div>
            <div
              style={{
                fontSize: "30px",
                color: "white",
                zIndex: 999,
              }}
            >
              What we Do
            </div>
            <div
              style={{
                borderBottom: "2px solid white",
                width: "100%",
                margin: "50px 0px 50px 0px",
              }}
            ></div>
            <div
              style={{
                fontSize: "45px",
                color: "white",
                zIndex: 999,
                textAlign: state.auth.isMobile ? "left" : "center",
              }}
            >
              Transforming businesses through technology.
            </div>
            <div
              onClick={() => {
                navigate("/about");
              }}
              style={{
                fontSize: "20px",
                color: "white",
                zIndex: 999,
                fontWeight: 600,
                cursor: "pointer",
                textDecoration: "underline",
              }}
            >
              Read more
            </div>
          </div>
        </div>
        <div style={{ height: "100vh" }}></div>
        <div style={{ height: "100px" }}></div>

        <div
          style={{
            fontSize: "30px",
            color: themeStyle.primaryColor,
            zIndex: 999,
            fontWeight: 600,
          }}
        >
          Services That Transform Your Business With Advanced Technologies
        </div>
        <News
          gallery={gallery.map((gall, index) => ({
            subtitle: gall["subtitle"],
            title: gall["title"],
            image: API_URL + gall["image"],
          }))}
        />
        <SpacerV height={"100px"} />

        <div
          className="anigrad"
          style={{
            display: state.auth.isMobile ? "none" : "block",
            height: "100vh",
            width: "100vw",
          }}
        >
          <div style={{ width: "100%", height: "100%" }}>
            {carouselFragment}
          </div>
        </div>

        {/* <div
          className="anigrad"
          style={{
            height: "100vh",
            maxWidth: "100vw",
            display: state.auth.isMobile ? "block" : "none",
          }}
        >
          <section>
            <div className={"vidhero"}>
              <div
                className="imgback"
                style={{
                  marginTop: "-25px",
                  borderRadius: "25px",
                  backgroundColor: "white",
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                  justifyContent: "center",
                  padding: "50px",
                  color: "black",
                }}
              >
                <div
                  style={{
                    marginTop: "-25px",
                    borderRadius: "25px",
                  }}
                >
                  <FormatQuoteIcon
                    style={{
                      fontSize: state.auth.isMobile ? "50px" : "100px",
                    }}
                  />
                </div>
                <div
                  style={{
                    fontSize: state.auth.isMobile ? "20px" : "30px",
                  }}
                >
                  The collaboration with your team has been nothing short of
                  extraordinary. Your innovative approach and attention to
                  detail have set a new benchmark in excellence. We're thrilled
                  to have partnered with you!
                </div>
                <div
                  style={{
                    borderRadius: "25px",
                  }}
                >
                  <FormatQuoteIcon
                    style={{
                      fontSize: state.auth.isMobile ? "50px" : "100px",
                    }}
                  />
                </div>
                <div
                  style={{
                    fontSize: state.auth.isMobile ? "15px" : "30px",
                  }}
                >
                  -Sarah Miller
                </div>
                <div
                  style={{
                    fontSize: state.auth.isMobile ? "10px" : "20px",
                    color: "grey",
                  }}
                >
                  CEO of TechVantage Solutions
                </div>
              </div>
              <animated.div
                onClick={() => {
                  slideToNextItem();
                }}
                onMouseEnter={() => {
                  zoom1api.start({
                    from: {
                      transform: "scale(1)",
                    },
                    to: {
                      transform: "scale(1.1)",
                    },
                  });
                }}
                onMouseLeave={() => {
                  zoom1api.start({
                    from: {
                      transform: "scale(1.1)",
                    },
                    to: {
                      transform: "scale(1)",
                    },
                  });
                }}
                style={{
                  display: state.auth.isMobile ? "none" : "flex",
                  position: "absolute",
                  width: "80px",
                  height: "80px",
                  border: "2px solid white",
                  borderRadius: "100px",
                  top: "20vh",
                  right: 75,
                  justifyContent: "center",
                  alignItems: "center",
                  cursor: "pointer",
                  ...zoom1,
                }}
              >
                <ArrowRightIcon style={{ fontSize: "75px", color: "white" }} />
              </animated.div>
              <animated.div
                onClick={() => {
                  slideToPrevItem();
                }}
                onMouseEnter={() => {
                  zoom2api.start({
                    from: {
                      transform: "scale(1)",
                    },
                    to: {
                      transform: "scale(1.1)",
                    },
                  });
                }}
                onMouseLeave={() => {
                  zoom2api.start({
                    from: {
                      transform: "scale(1.1)",
                    },
                    to: {
                      transform: "scale(1)",
                    },
                  });
                }}
                style={{
                  display: state.auth.isMobile ? "none" : "flex",
                  position: "absolute",
                  width: "80px",
                  height: "80px",
                  border: "2px solid white",
                  borderRadius: "100px",
                  top: "32vh",
                  right: 75,
                  justifyContent: "center",
                  alignItems: "center",
                  cursor: "pointer",
                  ...zoom2,
                }}
              >
                <ArrowLeftIcon style={{ fontSize: "75px", color: "white" }} />
              </animated.div>
            </div>
          </section>
        </div> */}

        <div style={{ backgroundColor: "white" }}>
          <div
            style={{
              height: "100vh",
              display: "flex",
              flexDirection: "column",
              justifyContent: "center",
              alignItems: "center",
              width: "100vw",
              marginTop: state.auth.isMobile ? "100px" : "0px",
            }}
          >
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                justifyContent: "flex-start",
                alignItems: "center",
                width: "75vw",
              }}
            >
              <div
                style={{
                  fontSize: state.auth.isMobile ? "30px" : "55px",
                  color: themeStyle.primaryColor,
                  fontWeight: 600,
                  zIndex: 999,
                }}
              >
                Give value to your users from something small
              </div>

              <div
                style={{
                  borderBottom: "2px solid black",
                  width: "100%",
                  margin: "25px 0px 25px 0px",
                }}
              ></div>
              <div
                style={{
                  fontSize: state.auth.isMobile ? "20px" : "35px",
                  color: "black",
                  zIndex: 999,
                  fontWeight: "500",
                }}
              >
                Your design looks like a developer created it, and you can`t get
                over it? We already have a solution to create a viable and
                good-looking product for your potential users and investors.
              </div>
              <div
                onClick={() => {
                  navigate("/about");
                }}
                style={{
                  fontSize: "20px",
                  color: "white",
                  zIndex: 999,
                  fontWeight: 600,
                  cursor: "pointer",
                  textDecoration: "underline",
                }}
              >
                Read more
              </div>
            </div>
          </div>
        </div>
        <div
          style={{
            fontSize: "30px",
            color: themeStyle.primaryColor,
            zIndex: 999,
            backgroundColor: "white",
            fontWeight: 600,
          }}
        >
          Get To Know Us Better
        </div>
        <Stats />
        <SpacerV height={"100px"} />
        <Footer />
      </div>
    );
  }

  return (
    <div
      style={{
        height: "100%",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        backgroundColor:
          state.auth.theme == "dark"
            ? themeStyleDark.backgroundColor
            : themeStyle.backgroundColor,
        transition: "opacity 2s",
      }}
    >
      {getContent()}
    </div>
  );
}
